import { Icon } from "@iconify/react/dist/iconify.js";
import BannerImage from "@resources/highlighted-apartment.jpg?format=webp&quality=80&w=1600;1200;1000;767;500&as=srcset&imagetools";
import Container from "@/Components/Grid/Container";

const FEATURES = [
    {
        icon: "icon-park-outline:local-two",
        label: <>Na inwestycji</>,
    },
    {
        icon: "hugeicons:key-01",
        label: (
            <>
                Wykończone
                <br />
                pod klucz
            </>
        ),
    },
    {
        icon: "uil:calendar",
        label: (
            <>
                Wizyty po
                <br />
                umówieniu
            </>
        ),
    },
] as const;

export const ShowApartmentBanner = () => {
    return (
        <section className="relative overflow-hidden bg-[#F9F9FB] lg:min-h-[646px] lg:py-0 py-10 mb-10 lg:mb-14">
            <div className="absolute inset-0 maxLg:hidden pointer-events-none">
                <img
                    srcSet={BannerImage}
                    alt=""
                    className="absolute right-0 top-0 h-full w-[50.5%] object-cover object-center"
                    loading="lazy"
                />
                <div className="absolute inset-y-0 left-0 w-[84%] bg-gradient-to-l from-[rgba(249,249,251,0.08)] to-[#F9F9FB] to-[42%]" />
            </div>

            <div className="lg:hidden mb-8">
                <img
                    srcSet={BannerImage}
                    alt="Mieszkanie pokazowe"
                    className="w-full h-[280px] object-cover"
                    loading="lazy"
                />
            </div>

            <Container className="relative z-10 lg:py-[104px] py-0">
                <div className="max-w-[760px]">
                    <h2 className="text-primary uppercase font-extrabold tracking-[1px] text-[40px] leading-[48px] maxMd:text-h3 maxMd:leading-h3 mb-6">
                        Zobacz mieszkanie
                        <br />
                        pokazowe na żywo
                    </h2>
                    <p className="text-primary text-h4 leading-h4 tracking-[0.6px] font-medium max-w-[433px] mb-10 maxMd:mb-8 maxMd:text-p maxMd:leading-p">
                        Zobacz standard, układ i jakość wykonania przed decyzją.
                    </p>

                    <div className="flex flex-wrap gap-8 maxMd:gap-4 mb-10 maxMd:mb-8">
                        <a
                            href="#contact-form"
                            className="button-primary bg-primary max-w-fit px-8 maxMd:w-full maxMd:max-w-full"
                        >
                            Umów wizytę
                        </a>
                        <a
                            href="#show-apartment-gallery"
                            className="button-outline border-primary border-[2px] max-w-fit px-8 maxMd:w-full maxMd:max-w-full"
                        >
                            Zobacz galerię
                        </a>
                    </div>

                    <div className="bg-white rounded-xl px-3 flex flex-wrap items-center gap-x-8 gap-y-2 max-w-fit maxMd:max-w-full maxMd:w-full maxMd:justify-center">
                        {FEATURES.map((feature) => (
                            <div
                                key={feature.icon}
                                className="flex items-center gap-5 p-4 maxMd:justify-center"
                            >
                                <Icon
                                    icon={feature.icon}
                                    width={40}
                                    height={40}
                                    className="text-primary shrink-0"
                                />
                                <p className="text-primary text-[16px] leading-6 font-extrabold tracking-[0.08px] uppercase text-center">
                                    {feature.label}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </Container>
        </section>
    );
};
